import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import classNames from 'classnames'
import React from 'react'
import {AddToCalendar} from './add-to-calendar'
import {DownloadPapyrusTickets} from './download-papyrus-tickets'
import {SuccessActionsProps} from './interfaces'
import s from './success-actions.scss'

const getButtonClasses = (primary: boolean = true) => {
  return classNames(s.actionButton, primary ? s.primary : s.secondary)
}

export const SuccessActions = ({
  t,
  className = '',
  calendarButtonText = t('ticketsThankYou.addToCalendar'),
  calendarLinks,
  addToCalendarClicked,
  downloadTicketsVisible,
  addToCalendarVisible,
  addToCalendarOptionClicked,
}: SuccessActionsProps) => {
  if (!downloadTicketsVisible && !addToCalendarVisible) {
    return null
  }

  return (
    <div className={className}>
      {downloadTicketsVisible && (
        <DownloadPapyrusTickets t={t} className={classNames(getButtonClasses(), s.primaryActionMargin)} />
      )}
      {addToCalendarVisible && (
        <AddToCalendar
          t={t}
          dataHook={DH.ADD_TO_CALENDAR}
          className={getButtonClasses(!downloadTicketsVisible)}
          buttonText={calendarButtonText}
          calendarLinks={calendarLinks}
          onClick={addToCalendarClicked}
          onOptionClick={addToCalendarOptionClicked}
        />
      )}
    </div>
  )
}
